export const pigsAnimations = {
  catching: 'catching',
  run: 'run',
  runStart: 'run_start',
  firstPartLoop: 'first_part_loop',
  $hide: 'hide',
  $show: 'show',
};

export const wolfAnimations = {
  catching: 'catching',
  closeMouth: 'close_mouth',
  run: 'run',
  firstPartLoop: 'first_part_loop',
  doorOpening: 'door_opening',
};

export const whiteWolfAnimations = {
  whiteWolf: 'white_wolf',
  whiteWolfSecond: 'white_wolf_2',
};

export const doorAnimations = {
  doorOpen: 'door_opening',
  doorClose: 'first_part_loop',
};

export const pigsButtonAnimations = {
  animation: 'animation',
};
